import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setSuccessfulAttempt,
  setType,
} from '../../procedures/initiateIv/store/initiateIv.actions'
import { setAddInitiateIVToTimeline } from '../store/quickActions.actions'
import { getInitiateIvOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { IInitiateIvOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { IOption } from '../../../common/common.types'

export function* setInitiateIVQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const { typeOptions }: IInitiateIvOptionsState = yield select(getInitiateIvOptionsSelector)
  const typeOption = typeOptions.find((option: IOption) => option.id === procedureAction)

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setType(typeOption ? typeOption : null))
  yield put(setAddInitiateIVToTimeline(true))
}

export function* setInitiateIVQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_INITIATE_IV_BUTTON_TYPE], setInitiateIVQuickAction)
}
